<template>
  <div v-if="popupVisible">
    <side-popup :title="title" :popupVisible="popupVisible" @onClose="onClose">
      <div class="rule-warp">
        <div v-html="boxInfo.content" class="html-box"></div>
      </div>
      <div slot="footer" style="padding: 10px 0;">
        <div @click="onClose" class="btn">确认</div>
      </div>
    </side-popup>
  </div>
</template>

<script>
import SidePopup from "@/g-components/side-black-popup.vue";
// import SidePopup from "@/g-components/side-popup.vue";

export default {
  components: {
    SidePopup
  },
  data() {
    return {
      boxInfo: {
        name: '',
        content: ''
      },
      isMobile: false,
      title: '加载中',
      popupVisible: false
    }
  },
  created() {
    // this.toggle('Member')
  },
  methods: {
    onClose() {
      this.popupVisible = false
      this.$emit('onClose', 'onClose')
    },
    toggleContent(title, content) {
      this.isMobile = window.innerWidth < 600
      this.title = title
      this.boxInfo['content'] = content
      this.popupVisible = true
    },
    toggle(key) {
      this.isMobile = window.innerWidth < 600
      this.getData(key)
    },
    getData(key) {
      this.$doGet("/api/setting.Accord/info", {
        accord_id: key
      }).then((res) => {
        this.title = res.data.name
        this.boxInfo = res.data
        this.popupVisible = true
      }).catch(() => { })
    }
  }
};
</script>

<style lang="less" scoped>
.rule-warp {
  font-size: 16px;
  line-height: 26px;
  color: #fff;
}
.btn {
  width: 150px;
  background-color: #ffc400;
  border: 0;
  color: #1a1c24;
  font-weight: 600;
  font-size: 16px;
  display: inline-block;
  line-height: 40px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
